import { DataProvider } from 'react-admin'
import { EngineMediaPackDto } from '../../dto/engine-media/engine-media-pack.dto'

const fakeFiles: EngineMediaPackDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
